import { useState } from 'react'

export default function Enquiry() {
  const [name, setName]       = useState('')
  const [email, setEmail]     = useState('')
  const [message, setMessage] = useState('')
  const [status, setStatus]   = useState(null) // null | 'sending' | 'sent' | 'error'

  const handleSubmit = async (e) => {
    e.preventDefault()
    setStatus('sending')
    try {
      const res = await fetch('/.netlify/functions/send-enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message }),
      })
      if (res.ok) {
        setStatus('sent')
        setName(''); setEmail(''); setMessage('')
      } else {
        setStatus('error')
      }
    } catch {
      setStatus('error')
    }
  }

  const inputStyle = {
    background: 'transparent',
    border: 'none',
    borderBottom: '1px solid rgba(255,255,255,0.12)',
    color: 'var(--bone)',
    fontFamily: 'var(--f-b)',
    fontWeight: 300,
    fontSize: 14,
    padding: '10px 0',
    outline: 'none',
    width: '100%',
    transition: 'border-color 0.2s',
  }

  return (
    <div style={{ background: '#111', padding: 'clamp(32px,5vw,48px)' }}>
      <div style={{
        display: 'grid', gridTemplateColumns: '1fr 1fr',
        gap: 'clamp(32px,5vw,64px)', alignItems: 'start',
      }}>
        <style>{`@media(max-width:640px){.enquiry-grid{grid-template-columns:1fr!important}}`}</style>

        {/* Left — copy */}
        <div className="enquiry-grid" style={{ display: 'contents' }}>
          <div>
            <div style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)', marginBottom: 16 }}>
              Get in touch
            </div>
            <div style={{ fontFamily: 'var(--f-d)', fontSize: 'clamp(28px,4vw,44px)', letterSpacing: '0.04em', lineHeight: 1, color: 'var(--bone)', marginBottom: 16 }}>
              Don't see a time that works?
            </div>
            <p style={{ fontSize: 13, fontWeight: 300, color: 'rgba(255,255,255,0.35)', lineHeight: 1.8 }}>
              Sessions can be arranged outside listed slots. Send me your availability and what you'd like to work on.
            </p>
          </div>

          {/* Right — form */}
          <div>
            {status === 'sent' ? (
              <div style={{ fontFamily: 'var(--f-m)', fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)', paddingTop: 8 }}>
                Message sent — I'll be in touch shortly.
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                <div>
                  <label style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)', display: 'block', marginBottom: 8 }}>Name</label>
                  <input required value={name} onChange={e => setName(e.target.value)} placeholder="Your name" style={inputStyle} />
                </div>
                <div>
                  <label style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)', display: 'block', marginBottom: 8 }}>Email</label>
                  <input required type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" style={inputStyle} />
                </div>
                <div>
                  <label style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)', display: 'block', marginBottom: 8 }}>Message</label>
                  <textarea required value={message} onChange={e => setMessage(e.target.value)} placeholder="What you'd like to work on, and your general availability…" rows={4}
                    style={{ ...inputStyle, resize: 'vertical', lineHeight: 1.6 }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                  <button type="submit" disabled={status === 'sending'}
                    style={{
                      fontFamily: 'var(--f-m)', fontSize: 10, letterSpacing: '0.22em',
                      textTransform: 'uppercase', padding: '13px 28px',
                      background: status === 'sending' ? 'transparent' : 'var(--bone)',
                      color: status === 'sending' ? 'rgba(255,255,255,0.25)' : 'var(--pitch)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: 2, cursor: status === 'sending' ? 'not-allowed' : 'pointer',
                      transition: 'all 0.2s',
                    }}>
                    {status === 'sending' ? 'Sending…' : 'Send →'}
                  </button>
                  {status === 'error' && (
                    <span style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#c46060' }}>
                      Something went wrong — try again
                    </span>
                  )}
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
